export default class GeofenceSiteModel {
  constructor(
    geofenceName,
    geofenceDescription,
    geofenceLatitude,
    geofenceLongitude,
    geofenceTag,
    siteId,
    siteName,
    siteLocation,
    siteRegion,
    siteLatitude,
    siteLongitude,
    siteDistanceFromCentroid,
    siteNetworkName,
    siteScreenCount,
    sitePhysicalScreenCount,
  ) {
    this.geofenceName = geofenceName;
    this.geofenceDescription = geofenceDescription;
    this.geofenceLatitude = geofenceLatitude;
    this.geofenceLongitude = geofenceLongitude;
    this.geofenceTag = geofenceTag;
    this.siteId = siteId;
    this.siteName = siteName;
    this.siteLocation = siteLocation;
    this.siteRegion = siteRegion;
    this.siteLatitude = siteLatitude;
    this.siteLongitude = siteLongitude;
    this.siteDistanceFromCentroid = siteDistanceFromCentroid;
    this.siteNetworkName = siteNetworkName;
    this.siteScreenCount = siteScreenCount;
    this.sitePhysicalScreenCount = sitePhysicalScreenCount;
  }

  get radius() {
    if (this.geofenceTag) {
      const tags = JSON.parse(this.geofenceTag);
      if (tags.isPoint) {
        return tags.radius;
      }
    }
    return undefined;
  }
}
